'use client'

import { motion } from 'motion/react'

import { PromotionBadgeIcon } from '@podo/assets'

const PromotionBadge = () => (
  <motion.div
    className="-bottom-[15px] absolute z-20"
    animate={{ y: [0, -5, 0, 5, 0] }}
    transition={{ repeat: Infinity, duration: 2, ease: 'easeInOut' }}
  >
    <PromotionBadgeIcon />
    <span className="absolute inset-0 flex items-center justify-center text-white text-[9px] font-bold translate-y-[2.5px]">
      NEW
    </span>
  </motion.div>
)

export default PromotionBadge
